<template>
  <Configurator />
</template>

<script>
import Configurator from "./components/Configurator.vue";

export default {
  name: "App",
  components: {
    Configurator,
  },
};
</script>

<style lang="scss">
$configurator-content-height: calc(100vh - 330px);

@font-face {
  font-family: "Avenir-Book";
  src: url("assets/fonts/Avenir-Book.eot?#iefix") format("embedded-opentype"),
    url("assets/fonts/Avenir-Book.otf") format("opentype"),
    url("assets/fonts/Avenir-Book.woff") format("woff"),
    url("assets/fonts/Avenir-Book.ttf") format("truetype"),
    url("assets/fonts/Avenir-Book.svg#Avenir-Book") format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "FreightDispBookItalic";
  src: url("assets/fonts/FreightDispBookItalic.eot?#iefix")
      format("embedded-opentype"),
    url("assets/fonts/FreightDispBookItalic.woff") format("woff"),
    url("assets/fonts/FreightDispBookItalic.ttf") format("truetype"),
    url("assets/fonts/FreightDispBookItalic.svg#FreightDispBookItalic")
      format("svg");
  font-weight: normal;
  font-style: normal;
}

html,
body {
  width: 100%;
  height: 100%;
  font-family: Avenir-Book, Helvetica, Arial, sans-serif;
  font-size: 14px;
  @media (max-width: 767px) {
    overflow-x: hidden;
  }
}

#app {
  font-family: Avenir-Book, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

a {
  color: black;
}

h1,
h2,
h3,
h4,
h5 {
  font-family: FreightDispBookItalic;
  letter-spacing: 1.25px;
}

h1 {
  font-size: 48px;
}
table{
  tr{
    &.line-through{
      text-decoration: line-through;
      display: none;
    }
  }
}
select {
  background-color: transparent;
  text-align: center;
  text-align-last: center;
  option {
    text-align: center;
  }
}

.btn {
    text-transform: uppercase;
    letter-spacing: 1.28px;
    min-height: 47px;
    line-height: 2;
    outline: none;
    transition: none;
    position: relative;
    text-decoration: none;
    box-shadow: none;
    margin: 0;
    border-radius: 0;
    padding: 15px 40px;
    &:hover {
        text-decoration: none;
    }
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus,
.btn-outline-primary:focus, .btn-outline-primary.focus,
.btn-black-bg:not(:disabled):not(.disabled):active:focus,
.btn-black-bg:not(:disabled):not(.disabled).active:focus,
.show>.btn-black-bg.dropdown-toggle:focus,
.btn-black-bg:focus, .btn-black-bg.focus, .btn-outline-dark:not(:disabled):not(.disabled):active:focus,
.btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-dark.dropdown-toggle:focus,
.btn-outline-dark:focus, .btn-outline-dark.focus,
.btn-secondary:not(:disabled):not(.disabled):active:focus,
.btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus,
.btn-secondary:focus, .btn-secondary.focus {
    box-shadow: none;
    position: relative;
}


.btn-outline-primary,
.btn-outline-dark,
.btn-secondary {
    transition: all .3s ease-in-out;
    font-size: 8px;
    color: #000000;
    border-color: #000000;
    background: transparent;
    border-radius: 0;
    &:before {
        content: '';
        position: absolute;
        z-index: -1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #000000;
        transform: scaleY(0);
        transform-origin: 50% 100%;
        transition: all .3s ease-in-out;
    }
    &:hover {
        background: #000000;
        border-color: #000000;
        &:before {
            transform: scaleY(1);
            color: #ffffff;
        }
    }
    &:disabled {
        cursor: not-allowed;
        color: #000000;
        &:hover {
            &:before {
                transform: scaleY(0);
            }
        }
    }
}
.btn:focus,
.btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle,.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active, .show>.btn-primary.dropdown-toggle,
.btn-outline-dark:not(:disabled):not(.disabled):active,
.btn-outline-dark:not(:disabled):not(.disabled).active,
.show > .btn-outline-dark.dropdown-toggle,.btn-dark:not(:disabled):not(.disabled).active,
.btn-dark:not(:disabled):not(.disabled):active, .show>.btn-dark.dropdown-toggle,
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle,.btn-dark:not(:disabled):not(.disabled).active,
.btn-dark:not(:disabled):not(.disabled):active, .show>.btn-dark.dropdown-toggle, .btn-primary:disabled,
.btn-secondary:disabled {
    background: #000000;
    color: #ffffff;
    border-color: #000000;

}

.btn-black-bg,
.btn-primary {
    background: #000000;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 8px;
    &:hover,
    &:focus {
      background: #000000;
      color: #ffffff;
      box-shadow: none;
    }
}
.btn-primary:not(:disabled):not(.disabled).active:focus, .btn-primary:not(:disabled):not(.disabled):active:focus, .show>.btn-primary.dropdown-toggle:focus {
  box-shadow: none;
}

.btn-secondary {
  &:hover {
    color: #000000;
  }
}

.underlined::after {
  content: "";
  width: 100%;
  border-bottom: 1px solid black;
  position: absolute;
  left: 0;
  bottom: -10px;
}

#loader {
  //display: none;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.85);
  z-index: 9999;
}


.general-title {
    font-size: 28px;
    font-family: FreightDispBookItalic;
    font-weight: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    display: block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.general-title-light {
    font-family: 'Avenir-Book';
    font-size: 22px;
    font-weight: 300;
}

.general-content {
    font-size: 16px;
    display: block;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-bottom: 0;
    font-family: 'Avenir-Book', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.bold {
  font-weight: 600;
}

.btn-outline-primary {
  border: 1px solid black;
}

.full-height {
  height: 100%;
}

.full-width {
  width: 100%;
}

.xl-content {
  max-width: 1024px;
  margin: 0 auto;
}

.lg-content {
  max-width: 860px;
  margin: 0 auto;
}

.md-content {
  max-width: 560px;
  margin: 0 auto;
}

.sm-content {
  max-width: 480px;
  margin: auto;
}

.xs-content {
  max-width: 280px;
}

.intro-background {
  background-image: url("/background-intro.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position-x: right;
  background-position-y: center;
}

.main-content {
  padding-top: 25px;
}

.uppercase {
  text-transform: uppercase;
  letter-spacing: 0.75px;
}

.center {
  text-align: center;
}

.small-text {
  font-size: 12px;
}

.xs-text {
  font-size: 10px;
}

input {
  font-size: 10px;
}

input[type="text"],
input[type="date"],
select {
  border: none;
  border-bottom: 1px solid black;
  outline: none;
}

.question-container {
  input[type="text"],
  input[type="date"],
  select {
    margin-right: 15px;
    font-size: 12px;
  }
}

a {
  color: black;
}
#app {
  margin-top: 0;
}

.header {
  height: 130px;
  border-bottom: 1px solid black;
  margin-left: 3rem;
  margin-right: 3rem;
  &>div {
    width: 33%;
  }
  .logo-wrapper {
    text-align: center;
  }
  .menu-icon {
    text-align: left;
    img {
      width: 30px;
      height: 21px;
    }
  }
  .loaders {
    text-align: right;
    letter-spacing: 1.5px;
    font-size: 10px;
  }
}

.nav-tabs {
  border-bottom: none;
  .nav-link {
    border: none !important;
    text-transform: uppercase;
    font-size: 12px;
    color: #666;
    text-align: left;
    padding: 0;
    margin-right: 25px;
    &.active {
      color: black;
      border-bottom: 1px solid black !important;
      padding-bottom: 6px;
      font-weight: bold;
    }
  }
}

.errors-wrapper {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
  transition: all .3s ease-in-out;
  transform: translateY(-10%);
  -webkit-transition: -webkit-transform 1200ms cubic-bezier(0.190, 1.000, 0.220, 1.000),opacity 1200ms cubic-bezier(0.190, 1.000, 0.220, 1.000);
  transition: transform 1200ms cubic-bezier(0.190, 1.000, 0.220, 1.000),opacity 1200ms cubic-bezier(0.190, 1.000, 0.220, 1.000);
  &.visible {
    opacity: 1;
    z-index: 9999;
    transform: translateY(0);
  }
  .error {
    background-color: rgba(255, 255, 255, 0.93);
    padding: 30px 50px;
    border-radius: 5px;
    outline: 2px solid rgba(0, 0, 0, 0.2);
    position: relative;
    display: flex;
    align-items: center;
    .message {
      font-size: 14px;
      letter-spacing: 1.96px;
      font-family: 'Avenir Book', sans-serif;
      text-transform: uppercase;
    }
    img {
      width: 40px;
      margin-right: 20px;
    }
    .close-button {
      position: absolute;
      top: 7px;
      right: 8px;
      height: 16px;
      width: 16px;
      opacity: 1;
      text-align: center;
      border-radius: 50%;
      line-height: 16px;
      color: rgba(0, 0, 0, 0.6);
      cursor: pointer;
      display: none;
    }
  }
}

.measures {
  .measure {
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid white;
    text-align: center;
    line-height: 26px;
    margin-right: 15px;
    font-family: FreightDispBookItalic;
    letter-spacing: 0.75px;
    font-size: 18px;
    cursor: pointer;
    &:hover,
    &.active {
      font-weight: 800;
      border: 1px solid black;
    }
  }
}

.card {
  margin-top: -1px;
  border-radius: 0;

  .card-title {
    font-size: 80%;
    text-transform: uppercase;
    margin-bottom: 0.8em;
    margin-top: 0.5em;
    font-weight: bold;
    cursor: pointer;
  }
}

.chevron {
  transition: transform 0.5s ease-in-out;
  background: #eee;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;

  &.upside-down {
    animation: 0.8s upside-down forwards;
  }
}

label {
  margin-bottom: 0;
  padding: 0.3em 0;
}

@keyframes upside-down {
  20% {
    background: #111;
    color: #eee;
    transform: rotate(0);
  }

  30% {
    transform: scale3d(1.8, 1.8, 1);
  }

  50% {
    transform: scale3d(1.2, 1.2, 1);
  }

  100% {
    background: #111;
    color: #eee;
    transform: rotate(-90deg) scale3d(1.1, 1.1, 1);
  }
}

.questionnare-wrapper {
  @media (min-width: 868px) {
    min-width: 860px;
  }
}

.questionnaire-prev {
  margin-right: 15px;
}

.skip-button {
  position: absolute;
  margin: 0 auto;
  bottom: 70px;
  text-decoration: none;
  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 0.0625rem;
    background: #000;
    transition: all .3s ease-in-out;
  }
  &:hover {
    color: #000000;
    text-decoration: none;
    &:after {
      width: 100%;
    }
  }
}

input:focus,
select:focus {
  border-color: rgb(87, 20, 20);
}

.filter-wrapper {
  .filter {
    display: inline-block;
    margin-right: 80px;
    div,
    ul,
    li {
      display: inline-block;
    }
    div {
      color: grey;
    }
    ul {
      padding-left: 20px;
    }
    li {
      margin-right: 15px;
    }
  }
}

.bikes-list {
  text-transform: uppercase;
  font-size: 12px;
  .bike {
    width: 200px;
    display: inline-block;
    margin-right: 30px;
    margin-bottom: 30px;
    img {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}

#cmp_imager {
  align-self: baseline;
}

@media print {
  .no-print {
    display: none;
  }
}

.configurator-content {
  display: flex;
  min-height: $configurator-content-height;
  #imager {
    width: 70%;
    padding: 0 5%;
    padding-top: 20px;
    svg {
      max-height: $configurator-content-height;
    }
  }
  .component-content {
    width: 30%;
    /*min-width: 280px;*/
    max-width: 270px;
    padding-top: 50px;
    position: relative;
    .component-content-scroll{
      padding: 0px 5px 15px;
      position: absolute;
      height: calc(100% - 75px);;
      width: 100%;
      top:20px;
      left:0px;
      overflow-y:auto;
    }
    .buttonset {
      position: absolute;
      bottom: 0px;
      left:0px;
      width: 100%;
      background: white;
      padding: 10px 0;
      margin-top: 20px;
      margin-bottom: 0px;
      min-height: 45px;
      display: flex;
      justify-content: space-between;
      &.flexend {
        justify-content: flex-end;
      }
    }
    ul {
      li {
        cursor: pointer;
      }
    }
  }
}

.main-content.full-height {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 150px);
}

.user-configurations {
  max-height: 300px;
  border: 1px solid black;
  overflow-x: none;
  overflow-y: auto;
  padding: 3px 5px;
}

.mt-6 {
  margin-top: 4rem;
}

.mt-7 {
  margin-top: 5rem;
}

.mt-8 {
  margin-top: 6rem;
}

.mt-9 {
  margin-top: 7rem;
}

.my-6 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.my-7 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.my-8 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.my-9 {
  margin-top: 7rem;
  margin-bottom: 7rem;
}

.menu-icon {
  cursor: pointer;
}

.close-menu {
  cursor: pointer;
  img {
    width: px2rem(25);
    transition: all .3s ease-in-out;

    &:hover {
        transform: rotate(90deg);
    }
  }
}

.main-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: transparent;
  &.visible {
    z-index: 999;
    background: rgba(0,0,0,.5);
  }
}

.main-menu {
  background-color: white;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 99;
  left: -100%;
  max-width: 340px;
  transition: all .3s ease-in-out;
  &.opened {
    left: 0;
  }
  .menu-wrapper {
    background-color: white;
    width: 340px;
    height: 100%;
    text-align: center;
    position: relative;
    .menu-logo {
      padding-top: 50px;
      img {
        width: 100px;
      }
    }
    .head-block {
      margin-top: 40px;
      ul {
        li {
          a {
            font-size: 12px;
            font-stretch: normal;
            letter-spacing: 1.92px;
            color: #000;
            text-transform: uppercase;
            font-weight: 500;
            text-decoration: none;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 0;
              height: 0.0625rem;
              background: #000;
              transition: all .3s ease-in-out;
            }
            &:hover {
              &:after {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .tail-block {
      position: absolute;
      width: 100%;
      bottom: 100px;
      ul {
        li {
          a {
            font-size: 12px;
            font-stretch: normal;
            letter-spacing: 1.92px;
            color: #000;
            text-transform: uppercase;
            font-weight: 500;
            text-decoration: none;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 0;
              height: 0.0625rem;
              background: #000;
              transition: all .3s ease-in-out;
            }
            &:hover {
              &:after {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .close-menu {
      position: absolute;
      bottom: 50px;
      width: 100%;
      img {
        margin: 0 auto;
        width: 1.5625rem;
        transition: all 0.3s ease-in-out;
      }
    }
    ul {
      padding: 0;
      li {
        list-style: none;
        text-transform: uppercase;
        margin-bottom: 20px;
      }
    }
  }
}

#buy-modal {
  .modal-header {
    border-bottom: none;
    padding-top: 40px;
  }
  .modal-footer {
    border-top: none;
  }

  .closer {
    cursor: pointer;
    font-size: 28px;
  }
}

.show-xs {
  display: none;
}

.hide-xs {
  display: inline-block;
}

@media (max-width: 767px) {
  .show-xs {
    display: inline-block;
  }

  .hide-xs {
    display: none;
  }
  .configurator-content{
      .component-content {

        .component-content-scroll{
          height: auto;

          overflow: inherit;
          position: relative;
        }
        .buttonset{
          position: relative;
        }
      }
  }

  .header {
    height: 90px;
    width: 100%;
    margin: 0;
    background: #ffffff;
    padding-left: 20px;
    padding-right: 20px;
    .logo-wrapper {
      width: 100%;
    }
    .menu-icon {
      position: absolute;
    }
    .loaders {
      display: none;
    }
  }

  .journey-steps-container {
    flex-direction: column;
    .journey-step {
      margin-bottom: 40px;
      width: 100%;
    }
  }

  .question-container {
    margin-top: 0px !important;
    flex-direction: column;
    position: relative;
    input[type="text"],
    input[type="email"],
    select {
      width: 100% !important;
      height: 50px;
      margin-bottom: 10px;
      margin-right: 0;
    }
    .questionnaire-next,
    .questionnaire-prev {
      // position: absolute;
      // bottom: -70px;
      max-width: 48%;
      margin-top: 20px;
    }
    .questionnaire-next {
      right: 0;
      order: 5;
      align-self: flex-end;
      margin-top: -47.5px;
    }
    .questionnaire-prev {
      left: 0;
      margin-right: 0;
      order: 4;
    }
  }

  .result-wrapper {
    display: block !important;
    .result {
      margin-top: 30px;
    }
  }

  .questionnaire-results {
    .all-models {
      width: 100%;
      text-align: center;
      margin-bottom: 100px;
      margin-top: 40px;
      position: relative !important;
      right: auto !important;
      top: auto !important;
    }
  }

  .selection-choose-bike {
    .configurations {
      display: block !important;
      margin-top: 40px !important;
      .configuration {
        width: 100% !important;
        margin-bottom: 30px;
      }
    }
  }

  .round-button-wrapper {
      display: none;
  }

  #configuration_id_wrapper {
    position: absolute;
    width: 100%;
    text-align: center;
    top: -30px;
    left: 0;
  }

  .summary-results {
    .info-items {
      flex-wrap: wrap;
      justify-content: center;
      .info-item {
        width: 50% !important;
        display: inline-block;
        vertical-align: text-top;
        margin-bottom: 20px;
      }
    }
    .summary-buttonset {
      #admin-section {
        display: none;
      }
    }
  }

  .container-fluid.px-5 {
    padding-left: 20px !important;
    padding-right: 20px !important;
    position: relative;
  }

  .content-wrapper {
    margin: 0;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .configurator-menu {
    @media (max-width: 767px) {
      padding-top: 0;
    }
    .arrow-container {
      position: absolute;
      width: 100%;
      z-index: 9;

      .arrow-left-wrapper,
      .arrow-right-wrapper {
        position: absolute;
        top: 12px;
        img {
          width: 30px;
        }
      }
      .arrow-right-wrapper {
        right: 41px;
      }
    }

    ul {
      li {
        display: none;
        position: absolute;
        left: 0;
        width: 100%;
        text-align: center;
        background-color: #eee;
        height: 50px;
        @media (max-width: 767px) {
          line-height: 50px;
        }
        &.active {
          display: block;
        }

        a {
            font-size: 12px;
            font-stretch: normal;
            letter-spacing: 1.92px;
            color: #000;
            text-transform: uppercase;
            font-weight: 500;
            text-decoration: none;
            position: relative;
            &:after {
              content: "";
              position: absolute;
              bottom: 0;
              left: 0;
              width: 0;
              height: 0.0625rem;
              background: #000;
              transition: all .3s ease-in-out;
            }
            &:hover {
              &:after {
                width: 100%;
              }
            }
          }

        a::after {
          display: none;
        }
      }
    }
  }

  .configurator-content {
    display: block;
    .component-content {
      width: 100%;
      min-width: auto;
    }
  }

  #cmp_imager {
    svg {
      height: 240px !important;
    }
  }

  .footer {
    .price-wrapper {
      display: none;
      width: 0;
    }
    .configurator-footer > div:nth-child(1) {
      width: 40%;
    }
    .configurator-footer > div:nth-child(3) {
      width: 60%;
    }
  }

  .filter-wrapper {
    .filter {
      display: block;
      margin-right: 0;
    }
  }

  .price-wrapper {
    h3 {
      font-size: 20px;
    }
  }

  .intro-background {
    background-position-x: center;
    background-size: cover;
    height: 100vh;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255,255,255,.2);
      z-index: -1;
    }
  }

  .bikes-list {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .bikes-list .bike {
    margin-right: 0;
    margin-bottom: 30px;
    width: 50%;
  }

  .summary-buttonset {
    margin-top: 0 !important;
    .d-flex {
      display: block !important;
    }
  }
}


#infobox{
  &.fade{
    .modal-dialog{
      -webkit-transform: translate(50px,0);
      transform: translate(50px,0);
    }
  }
  &.show{
    .modal-dialog {
      -webkit-transform: none;
      transform: none;
    }
  }
      .modal-dialog{
        min-height: 100%;
        margin: 0;
        right: 0px;
        left: auto;
        position: absolute;
        width: 100%;
        max-width: 500px;
        .modal-content{
          min-height: 100%;
          max-height: 100%;
          position: absolute;
          .modal-body{
            max-height: 100%;
            overflow-y: auto;
            img{
              max-width: 80%;
              margin-bottom: 10px;
            }
          }
        }
      }
}

</style>
